import { render, staticRenderFns } from "./WalletTransactionLog.vue?vue&type=template&id=e842e422&scoped=true&"
import script from "./WalletTransactionLog.vue?vue&type=script&lang=js&"
export * from "./WalletTransactionLog.vue?vue&type=script&lang=js&"
import style0 from "./WalletTransactionLog.vue?vue&type=style&index=0&id=e842e422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e842e422",
  null
  
)

export default component.exports